import { Component, OnInit, Input } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular';
import { PaymentModalComponent } from '../../payment-modal/payment-modal.component';
import { CryptoService } from '../../../services/crypto.service';
import { alertController } from '../../../../../node_modules/@ionic/core';
import { StorageService } from 'src/app/services/storageService.service';
import { ApiPaymentService } from 'src/app/api-services/payment.api.service';
import { MessagesService } from 'src/app/services/messages.service';

@Component({
  selector: 'app-package-card',
  templateUrl: './package-card.component.html',
  styleUrls: ['./package-card.component.scss'],
})
export class PackageCardComponent implements OnInit {
  @Input('cardTitle') cardTitle: string;
  @Input('displayPaymentLength') displayPaymentLength: boolean;
  @Input('price') price: string;
  @Input('price2') price2: string;
  @Input('headerColourPurple') headerColourPurple: boolean;
  @Input('headerColourGreen') headerColourGreen: boolean;
  @Input('headerColourBlue') headerColourBlue: boolean;
  @Input('features') features: [];
  @Input('displayQuantities') displayQuantities: boolean;
  @Input('productId') productId: number;
  @Input('productMonthlyId') productMonthlyId: number;
  @Input('displayFull') displayFull: boolean;
  @Input('pausePayments') pausePayments: boolean;
  public selected: string = "yearly";
  public quantity: string = "1";
  public _isModalOpen: boolean = false;

  constructor(
    public alertController: AlertController,
    public modalController: ModalController,
    public cryptoService: CryptoService,
    public storageService: StorageService,
    private paymentApiService: ApiPaymentService,
    private messageService: MessagesService
  ) { }

  ngOnInit() { }

  setSelected(tab) {
    this.selected = tab;
  }

  cancelModal() {
    this.modalController.dismiss();
  }

  async purchase(pausedPayment) {
      if (this._isModalOpen === true) return;
      this._isModalOpen = true;

      const purchaseModal = await this.modalController.create({
        component: PaymentModalComponent,
        id: 'payment-modal',
        componentProps: {
          "customerId": +this.cryptoService.decryptData(this.storageService.getItem('customerId')),
          "productId": this.selected == "yearly" ? this.productId : this.productMonthlyId,
          "pausePayment": pausedPayment
        },
      });

      purchaseModal.onDidDismiss().then(result => {
        this._isModalOpen = false;
      });

      return await purchaseModal.present();
  }

  request(pausedPayment) {
      let customerId = Number(this.cryptoService.decryptData(this.storageService.getItem('customerId')));
      let productId = this.selected == "yearly" ? this.productId : this.productMonthlyId;

      this.messageService.presentLoadingWindow("Sending e-mail request");
      this.paymentApiService.processBuyRequest(customerId, productId).subscribe(x => {        
        this.messageService.loadingWindow.dismiss();
        this.messageService.presentToast("E-mail sent.", "success", "Purchase Request");
        this.cancelModal();
      });
  }
}